export enum NavItemsType {
  // SIDEBAR
  TITLE = 'TITLE',
  TOGGLE = 'TOGGLE',

  // NAVBAR (elementi custom)
  LOGO = 'LOGO',
  USER = 'USER',
  SESSION_NOTIFICATION = 'SESSION_NOTIFICATION',

  // GENERIC
  DOWNLOAD_MANUAL = 'DOWNLOAD_MANUAL',
  BUTTON = 'BUTTON',
  MENU = 'MENU',
  CANDIDATES = 'CANDIDATES',
  STORAGE = 'STORAGE',
  SEPARATOR = 'SEPARATOR',
  LINK = 'LINK',
  LINK_SEPARATOR = 'LINK_SEPARATOR',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
  SUPPORT = 'SUPPORT',
  ANY_PERMISSION = 'ANY_PERMISSION'
}
